"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _material = require("@mui/material");
var _TextField = _interopRequireDefault(require("@mui/material/TextField"));
var _styles = require("@mui/styles");
var _Typography = _interopRequireDefault(require("@mui/material/Typography"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _CustomNumber = _interopRequireDefault(require("./CustomNumber"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var styles = function styles(theme) {
  return {
    radioButton: {
      display: 'flex',
      alignItems: 'center'
    },
    formControlLabel: {
      maxHeight: theme.spacing(4),
      marginLeft: '0 !important'
    }
  };
};
var CustomCheckboxText = /*#__PURE__*/function (_Component) {
  function CustomCheckboxText(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, CustomCheckboxText);
    _this = _callSuper(this, CustomCheckboxText, [props]);
    (0, _defineProperty2["default"])(_this, "updateSelectedItem", function (valueID) {
      return function (event) {
        var selectedItems = [].concat(_this.state.selectedItems);
        if (event.target.checked) {
          selectedItems.push({
            valueID: valueID,
            checked: true,
            valueText: ''
          });
        } else {
          selectedItems = selectedItems.filter(function (r) {
            return Number(r.valueID) !== Number(valueID);
          });
        }
        _this.setState({
          selectedItems: selectedItems
        });
        _this.props.onChange(_this.convertToValue(selectedItems));
      };
    });
    ['updateSelectedItem', 'updateValueText', 'convertToValue', 'updateSurvey', 'updateNumber'].map(function (k) {
      return _this[k] = _this[k].bind(_this);
    });
    var value = props.value;
    var _selectedItems = value ? value.map(function (v, index) {
      var a = JSON.parse(v);
      var valueID = a.valueID;
      var valueText = a.valueText;
      return {
        valueID: valueID,
        valueText: valueText,
        checked: true
      };
    }) : [];
    _this.state = {
      selectedItems: _selectedItems
    };
    return _this;
  }
  (0, _inherits2["default"])(CustomCheckboxText, _Component);
  return (0, _createClass2["default"])(CustomCheckboxText, [{
    key: "updateValueText",
    value: function updateValueText(valueID) {
      var _this2 = this;
      var validationRule = this.props.validationRule;
      var isPercent = validationRule && validationRule.validatorFunctionName === 'isPercent';
      return function (value) {
        var selectedItems = [].concat(_this2.state.selectedItems);
        var selectedItem = selectedItems.find(function (s) {
          return Number(s.valueID) === Number(valueID);
        });
        if (selectedItem) {
          selectedItem.valueText = value.target.value;
        }
        _this2.setState({
          selectedItems: selectedItems
        });
      };
    }
  }, {
    key: "updateNumber",
    value: function updateNumber(valueID, valueText) {
      var selectedItems = [].concat(this.state.selectedItems);
      var selectedItem = selectedItems.find(function (s) {
        return Number(s.valueID) === Number(valueID);
      });
      if (selectedItem) {
        selectedItem.valueText = valueText;
      }
      this.setState({
        selectedItems: selectedItems
      });
      this.props.onChange(this.convertToValue(this.state.selectedItems));
    }
  }, {
    key: "updateSurvey",
    value: function updateSurvey() {
      this.props.onChange(this.convertToValue(this.state.selectedItems));
    }
  }, {
    key: "convertToValue",
    value: function convertToValue(services) {
      var value = services.map(function (r) {
        return JSON.stringify({
          valueID: r.valueID ? r.valueID : '',
          valueText: r.valueText
        });
      });
      return value;
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      var _this$props = this.props,
        classes = _this$props.classes,
        validationRule = _this$props.validationRule;
      var selectedItems = this.state.selectedItems;
      var props = Object.assign({}, this.props);
      delete props.name;
      props.classes = Object.assign({}, this.props.classes);
      delete props.previousValue;
      delete props.classes.radioButton;
      delete props.classes.formControlLabel;
      delete props.validationRule;
      var isPercent = validationRule && validationRule.validatorFunctionName === 'isPercent';
      var isNum = validationRule && validationRule.validatorFunctionName === 'isFloat';
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: classes.radioButton
      }, /*#__PURE__*/_react["default"].createElement(_material.FormGroup, (0, _extends2["default"])({}, props, {
        style: {
          flexDirection: 'column'
        }
      }), this.props.answers.map(function (item) {
        var selectedItem = selectedItems.find(function (s) {
          return s.valueID == item.value;
        });
        return /*#__PURE__*/_react["default"].createElement(_react.Fragment, {
          key: "wrapper-".concat(item.value)
        }, /*#__PURE__*/_react["default"].createElement(_material.FormControlLabel, {
          className: classes.formControlLabel,
          key: 'checkbox-' + item.value,
          control: /*#__PURE__*/_react["default"].createElement(_material.Checkbox, {
            checked: selectedItem && selectedItem.checked ? selectedItem.checked : false,
            onChange: _this3.updateSelectedItem(item.value)
          }),
          label: /*#__PURE__*/_react["default"].createElement("div", {
            style: {
              display: 'flex',
              alignItems: 'center'
            }
          }, /*#__PURE__*/_react["default"].createElement(_Typography["default"], null, item.label))
        }), selectedItem && !isPercent && !isNum && /*#__PURE__*/_react["default"].createElement(_material.FormControlLabel, {
          className: classes.formControlLabel,
          key: 'percent-' + item.value,
          control: /*#__PURE__*/_react["default"].createElement(_TextField["default"], {
            key: 'percent' + item.value,
            type: 'text',
            defaultValue: selectedItem.valueText || '',
            onBlur: _this3.updateSurvey,
            value: selectedItem.valueText || '',
            onChange: _this3.updateValueText(item.value),
            inputProps: {
              min: isPercent ? 0 : null,
              max: isPercent ? 100 : null,
              step: 1,
              style: {
                textAlign: 'right'
              }
            }
          })
        }), selectedItem && (isPercent || isNum) && /*#__PURE__*/_react["default"].createElement(_material.FormControlLabel, {
          className: classes.formControlLabel,
          key: 'percent-' + item.value,
          control: /*#__PURE__*/_react["default"].createElement(_CustomNumber["default"], {
            value: selectedItem.valueText,
            key: 'percent' + item.value,
            onChange: function onChange(val) {
              return _this3.updateNumber(item.value, val);
            },
            suffix: "%",
            isAllowed: function isAllowed(val) {
              var value = val.value;
              if (isPercent) return value >= 0 && value <= 100;else return true;
            },
            decimalSeparator: _this3.props.language === null || _this3.props.language === 'English' || _this3.props.language === "British English" ? "." : ",",
            thousandSeparator: _this3.props.language === null || _this3.props.language === 'English' || _this3.props.language === "British English" ? "," : "."
          })
        }));
      })));
    }
  }]);
}(_react.Component);
CustomCheckboxText.propTypes = {
  answers: _propTypes["default"].array,
  onChange: _propTypes["default"].func.isRequired
};
var _default = exports["default"] = (0, _styles.withStyles)(styles)(CustomCheckboxText);